import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Home, BoxList, Details, Faqs, Profile, Edit, MyBoxes } from '@/pages';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { RouteKeys } from '@/configs';
import { Fragment, useEffect } from 'react';
const ScrollToTop = withRouter(({ history }) => {
    useEffect(() => {
        return history.listen(() => {
            window.scrollTo({
                top: 0,
            });
        });
    }, []);
    return null;
});
export const Routes = () => (_jsxs(Fragment, { children: [_jsx(ScrollToTop, {}), _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: RouteKeys.Home, component: Home }), _jsx(Route, { path: RouteKeys.BoxList, component: BoxList }), _jsx(Route, { path: RouteKeys.Details, component: Details }), _jsx(Route, { path: RouteKeys.Edit, component: Edit }), _jsx(Route, { path: RouteKeys.Faqs, component: Faqs }), _jsx(Route, { path: RouteKeys.Profile, component: Profile }), _jsx(Route, { path: RouteKeys.MyMaskboxes, component: MyBoxes }), _jsx(Redirect, { to: RouteKeys.Home })] })] }));
